import {Badge, Box, Button, ScrollArea, Table, Text} from "@mantine/core";
import {CheckCircle2, Trash2} from "lucide-react";

import {useTranslation} from "react-i18next";
import {useLocation} from "wouter";

import useRepos from "./repoProvider";

const RepositoryTable = ({user}) => {
    const {data: repos} = useRepos(user);
    const {t} = useTranslation();

    console.log("repos",repos);

    const repoView = repos?.map((repo) => {
        return <RepoRow key={repo.name} row={repo} owner={user}/>;
       });

    return <ScrollArea>
                    <Table striped highlightOnHover withTableBorder withColumnBorders>
                      <thead>
                        <tr>
                          <th>{t('Repository')}</th>
                          <th>{t('Status')}</th>
                          <th>{t('Last Anchored')}</th>
                          <th>{t('Total Proofs')}</th>
                          <th>{t('Actions')}</th>
                        </tr>
                      </thead>
                      <tbody>

                      {repoView}
                      </tbody>
                    </Table>
                  </ScrollArea>;
    }

const RepoRow = ({row, owner}) => {
    const {t} = useTranslation();
    const [location, setLocation] = useLocation();
    const handleClick = () => {
        setLocation(`/status/${owner}/${row.name}`)
        }

    return  <tr key={row.name}>
                <td>
                  <Box px="sm" py={4}>
                    <Text fw={600} onClick={handleClick}>{owner}/{row.name}</Text>
                  </Box>
                </td>
                <td>
                {row.status === 'active' ? (
                    <Badge variant="light" color="teal" leftSection={<CheckCircle2 size={10} />}>
                      {t('Active')}
                    </Badge>
                      ) : (
                    <Badge variant="light" color="blue">
                      {t('Paused')}
                    </Badge>
                    )}
                </td>
                <td>{row?.stamp}</td>
                <td>{row?.commits}</td>
                <td>
                  {row.status === 'active' ? (
                    <Button variant="subtle" color="red" leftSection={<Trash2 size={14} />}>
                      {t('Stop Tracking')}
                    </Button>
                      ) : (
                    <Button variant="default">{t('Resume')}</Button>
                    )}
                </td>
            </tr>;
    }

export default RepositoryTable;